import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { first } from 'rxjs/operators';
import { CovanceGridColumn, BooleanAgFloatingFilterComponent, BooleanCellRendererParams, BooleanAgFloatingFilterParams, BooleanCellValue } from '../../covance-ag-grid';
import { Protocol, AdminProtocolsStorage } from '../shared';
import { ProtocolChangeAccessibilityComponent } from './protocol-change-accessibility.component';
import { comparators } from '../../core';

@Component({
    selector: 'protocol-activation',
    template: require('./protocol-activation.component.html'),
    styles: [require('./protocol-activation.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProtocolActivationComponent {
    public gridOptions: GridOptions;

    public columnDefs: CovanceGridColumn[];

    public protocolItems: Protocol[];

    constructor(private protocolsStorage: AdminProtocolsStorage, private changeDetectorRef: ChangeDetectorRef) {
        this.protocolsStorage.all.pipe(first())
            .subscribe(protocols => {
                this.protocolItems = protocols;
                this.changeDetectorRef.markForCheck();
            });

        this.columnDefs = this.getGridColumns();

        this.gridOptions = {
            enableFilter: false,
            floatingFilter: true,
            rowHeight: 27,
            enableSorting: true
        };
    }

    private getGridColumns(): CovanceGridColumn[] {
        const activeInativeRenderer = (value: BooleanCellValue) => value === 'true' ? 'Active' : 'Inactive';
        const columns: CovanceGridColumn[] = [
            {
                headerName: 'Sponsor',
                field: 'sponsor',
                suppressFilter: true,
                comparator: (a, b) => comparators.mixedStringComparator(a, b),
            },
            {
                headerName: 'Protocol',
                field: 'protocolName',
                suppressFilter: true,
                comparator: (a, b) => comparators.mixedStringComparator(a, b),
            },
            {
                headerName: 'Projects',
                field: 'projects',
                suppressFilter: true,
                valueGetter: (value) => (value.data.projects as string[]).join(', '),
            },
            {
                headerName: 'Accessible',
                field: 'isAccessible',
                cellRendererFramework: ProtocolChangeAccessibilityComponent,
                filter: 'agSetColumnFilter',
                filterParams: {
                    values: ['true', 'false'],
                    cellRenderer: (params: BooleanCellRendererParams) => activeInativeRenderer(params.value)
                },
                floatingFilterComponentFramework: BooleanAgFloatingFilterComponent,
                floatingFilterComponentParams: {
                    booleanValueRenderer: activeInativeRenderer
                } as BooleanAgFloatingFilterParams
            },
        ];
        return columns;
    }
}